import React, {Component} from 'react';
import Utils from './../../Utils/Utility'

export default class TableHolderCustom extends Component {


    renderHeader() {
        const {columns} = this.props;
        const colArray = [];
        colArray.push(<th scope="col" className={"table-col"} key={"heading"}></th>)
        for (const col in columns) {
            if (columns.hasOwnProperty(col)) {
                colArray.push(<th scope="col" className={"table-col"} key={col}><b>{columns[col].label}</b></th>)
            }
        }
        return <tr>{colArray}</tr>

    }

    renderRow(rowVal, key) {

        const {columns,countDefault} = this.props;

        const colArray = [];

        colArray.push(<td key={"row"}>{countDefault + key + 1}</td>)
        for (const col in columns) {
            if (columns.hasOwnProperty(col)) {
                if(columns[col].Cell){
                    colArray.push(<td  key={col}>{columns[col].Cell(rowVal)}</td>);
                }else if (columns[col].prefix) {
                    var rowData =  rowVal[col] ? columns[col].prefix + rowVal[col] : null;
                    colArray.push(<td  key={col}>{rowData}</td>)
                }
                else {
                    colArray.push(<td  key={col}>{rowVal[col]}</td>)
                }
            }
        }

        return <tr key={key}>{colArray}</tr>
    }

    render() {
        const {tableData, columns, isPrevBtnActive, isNextBtnActive, pagination, btnPrevClick, btnNextClick,customClass} = this.props;

        return (
            <div className={"row"}>
                {
                    (pagination == true) ?
                        <ul className="pager">
                            {
                                (isPrevBtnActive === 'disabled') ?
                                    <li className="previous disabled"><a className={"previous-button"}
                                        href="JavaScript:void(0);">Previous</a></li>
                                    :
                                    <li className="previous"><a className={"previous-button"} href="JavaScript:void(0);"
                                                                onClick={btnPrevClick}>Previous</a>
                                    </li>
                            }
                            {
                                (isNextBtnActive === 'disabled') ?
                                    <li className="next disabled"><a className={"next-button"}
                                        href="JavaScript:void(0);">Next</a></li>
                                    :
                                    <li className="next"><a className={"next-button"} href="JavaScript:void(0);"
                                                            onClick={btnNextClick}>Next</a>
                                    </li>
                            }
                        </ul>
                        : null
                }
                <div className={customClass ? customClass : "table-responsive"}>
                    <table className="table table-striped" id={"table-stripe-custom"}>
                        <tbody>
                        {this.renderHeader()}
                        {tableData && tableData.map((rowVal, key) => this.renderRow(rowVal, key))}
                        </tbody>
                    </table>
                </div>
                {
                    (pagination == true) ?
                        <ul className="pager">
                            {
                                (isPrevBtnActive === 'disabled') ?
                                    <li className="previous disabled"><a className={"previous-button"}
                                        href="JavaScript:void(0);">Previous</a></li>
                                    :
                                    <li className="previous"><a className={"previous-button"} href="JavaScript:void(0);"
                                                                onClick={btnPrevClick}>Previous</a>
                                    </li>
                            }
                            {
                                (isNextBtnActive === 'disabled') ?
                                    <li className="next disabled"><a className={"next-button"}
                                        href="JavaScript:void(0);">Next</a></li>
                                    :
                                    <li className="next"><a className={"next-button"} href="JavaScript:void(0);"
                                                            onClick={btnNextClick}>Next</a>
                                    </li>
                            }
                        </ul>
                        : null
                }
            </div>
        );
    }

}



// WEBPACK FOOTER //
// src/components/visualization/table-holder-custom.js